import {supabase} from '../supabase/client';
import {normalizeBusinessRegion} from '../i18n/countryConfig';

export const BUSINESSES_TABLE = 'businesses_1772928300000';
export const MEMBERSHIPS_TABLE = 'business_memberships_1772928400000';

export async function listBusinesses(userId) {
  if (!supabase) {
    throw new Error('Supabase is not configured.');
  }

  const {data, error} = await supabase
    .from(BUSINESSES_TABLE)
    .select('*')
    .eq('is_active', true)
    .order('created_at', {ascending: true});

  if (error) {
    throw error;
  }

  // RLS returns owned, internal-member, and explicitly scoped accountant
  // Businesses. Do not re-filter here or accepted accountants receive an empty workspace.
  return data || [];
}

export async function createBusiness(userId, values) {
  if (!supabase) {
    throw new Error('Supabase is not configured.');
  }

  if (!userId) {
    throw new Error('Authentication is required.');
  }

  const region = normalizeBusinessRegion(values);

  const {data, error} = await supabase.rpc(
    'create_business_with_membership_1772933000000',
    {
      p_name: values.name,
      p_description: values.description || '',
      p_legal_structure: values.legalStructure || 'sole_proprietorship',
      p_currency: region.currency,
      p_fiscal_year_end: values.fiscalYearEnd || null,
      p_gst_hst_number: values.gstHstNumber || null,
      p_country: region.country,
      p_province: region.province
    }
  );

  if (error) {
    throw error;
  }

  if (!data) {
    throw new Error('Business creation returned no Business.');
  }

  return data;
}

export async function updateBusiness(businessId, values) {
  if (!supabase) {
    throw new Error('Supabase is not configured.');
  }

  const {data, error} = await supabase
    .from(BUSINESSES_TABLE)
    .update({
      name: values.name.trim(),
      description: values.description?.trim() || '',
      legal_structure: values.legalStructure,
      fiscal_year_end: values.fiscalYearEnd,
      gst_hst_number: values.gstHstNumber?.trim() || null
    })
    .eq('id', businessId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}
